import Select from 'react-select';
import { FieldWrapper } from './FieldWrapper';
import { Purpose } from 'features/pigeonLoans/tips/Purpose';

export const ReactDateFieldWithInfo = (props) => {
  const {
    id,
    type = 'date',
    label,
    className,
    onChange,
    maxLength,
    minLength,
    caption,
    registration,
    placeholder,
    error,
    required,
    name,
    value,
    infoTitle,
    infoDescription,
  } = props;


  return (
    <>
      <div className="flex flex-row items-center justify-between">
        <div className="block text-sm font-medium text-gray-700 dark:text-gray-400">
          {label}
        </div>
        <Purpose title={infoTitle} description={infoDescription} />
      </div>
      <div className="relative">
        <div className="my-1 text-xs text-gray-500 flex justify-start">{caption}</div>
        <input
          id={id}
          name={name}
          value={value}
          type={type}
          maxLength={maxLength}
          minLength={minLength}
          className="mb-3 appearance-none block w-full px-3 py-3 border dark:bg-gray-700 dark:border-none border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          required={required}
          placeholder={placeholder}
          onChange={onChange}
        />
      </div>
      {error?.message && (
        <div role="alert" aria-label={error.message} className="text-sm font-semibold text-red-500">
          {error.message}
        </div>
      )}
    </>
  );
};
